import React from 'react';
import Screens from '../../screens';

const Profile = () => {
	return (
		 <Screens.Home.Profile/>
	);
};

export default Profile;
